const getNativeWallet = (state) => state.nativeWallet || {};

export const getCanAddPaymentPass = (state) =>
    getNativeWallet(state).canAddPaymentPass;

export const getHasPaymentPass = (state) =>
    getNativeWallet(state).hasPaymentPass;
